import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ActivityLogs, ActivityLogStatusEnum } from '../activity-logs-dto';
import { SigningStatusEnum } from 'app/main/signing-pages/enums/enum';
import { RoleDetail } from 'app/main/signing-pages/signing-page/signing-page.dto';

@Component({
  selector: 'app-sender-activity',
  templateUrl: './sender-activity.component.html',
  styleUrl: './sender-activity.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SenderActivityComponent {

  @Input() activity: ActivityLogs;
  @Input() roleDetail: RoleDetail;
  public activityLogStatusEnum = ActivityLogStatusEnum;
  public signingStatusEnum = SigningStatusEnum;
  
}
